export enum TripDateType {
    ConsigneeNotificationDate = '1',
    ConsigneeDeliveryDate = '2',
    ConsigneeReleaseDate = '3',
    TripCloseDate = '4',
}
